// This file should only contain action type constants.
export const SET_HOURS = 'SET_HOURS';
